import styled from 'styled-components';
import { playGrey15 } from '../../ui-components/design-tokens';
import { VisuallyHidden } from '../../ui-components/utils.styles';

export const StyledExternalTeasers = styled.section`
    border-bottom: 1px solid ${playGrey15};
    padding-top: 45px;
    padding-bottom: 45px;

    .app & {
        display: none;
    }
`;

export const Heading = styled.h1`
    ${VisuallyHidden}
`;

export const ExternalTeasersList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;
